import { Tooltip } from 'antd';
import clsx from 'clsx';
import { LogOut } from 'lucide-react';
import { Link } from 'react-router';
import { useCurrentUser } from '../auth/CurrentUserProvider';
import { useSignOut } from '../auth/use-sign-out';
import { initials } from '../lib/initials';

export function SidebarUser({ collapsed }: { collapsed: boolean }) {
  const { state } = useCurrentUser();
  const signOut = useSignOut();
  const user = state.status === 'authenticated' ? state.user : undefined;

  const signOutButton = (
    <Tooltip title="Sign out" placement={collapsed ? 'right' : 'top'}>
      <button
        type="button"
        aria-label="Sign out"
        onClick={signOut}
        className="grid size-7 shrink-0 place-items-center rounded-md text-muted transition-colors hover:bg-sider-selected hover:text-fg"
      >
        <LogOut className="size-4" />
      </button>
    </Tooltip>
  );

  if (collapsed || !user) return <div className={clsx('flex', collapsed && 'justify-center')}>{signOutButton}</div>;

  return (
    <div className="flex items-center gap-2.5 rounded-lg p-1.5">
      <Link to="/account/security" className="flex min-w-0 flex-1 items-center gap-2.5 rounded-md hover:bg-sider-selected">
        <div className="grid size-8 shrink-0 place-items-center rounded-full bg-primary/10 text-xs font-semibold text-primary ring-1 ring-primary/20">
          {initials(user.name, user.email)}
        </div>
        <div className="min-w-0 flex-1 leading-tight">
          <p className="truncate text-[13px] font-medium text-fg">{user.name}</p>
          <p className="truncate text-xs text-muted">{user.email}</p>
        </div>
      </Link>
      {signOutButton}
    </div>
  );
}
